import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { LoadScript } from '@react-google-maps/api';
import initAuth0 from '@/shared/components/account/auth/withAuth0';
import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
import Loading from '@/shared/components/Loading';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import GlobalStyles from './globalStyles';
import RechartStyles from './rechartStyles';
import NotificationStyles from './notificationStyles';
import { useGoogleAnalytics } from '../useGoogleAnalutics/useGoogleAnalytics';
import ReactGA from 'react-ga';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

i18n.init(i18nextConfig);

const ThemeComponent = ({
  children,
}) => {
  const {
    mode, direction, shadow, border,
  } = useSelector(state => ({
    mode: state.theme.className,
    direction: state.rtl.direction,
    shadow: state.shadow.className,
    border: state.border.className,
  }));

  const theme = createTheme({
    palette: {
      type: mode,
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider
        theme={{
          mode,
          direction,
          shadow,
          border,
        }}
      >
        <GlobalStyles />
        <NotificationStyles />
        <RechartStyles />
        <TimepickerStyles />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedThemeComponent = ThemeComponent;

const App = () => {
  useEffect(() => {
    window.addEventListener('load', initAuth0);
  }, []);
  useGoogleAnalytics();

  // Initialize React Ga with your tracking ID
  ReactGA.initialize('UA-214514439-1');
  const stripePromise = loadStripe("pk_test_51MtYVNDeqTr21MNbcPq8e1zyboD9y6WryedsAsdZHRFhcfbd43CX1UdEUa3Kk6z1DJmRucq6wEB8GKq9rKXp6OZI006CmwhU2p");


  return (
    <Provider store={store}>
      <Elements stripe={stripePromise}>
        <BrowserRouter basename="/">
          <I18nextProvider i18n={i18n}>
            <ConnectedThemeComponent>
              <LoadScript
                loadingElement={<Loading loading />}
                googleMapsApiKey="AIzaSyCYx6E7TSAHDQMFB41DNksmX7v3zXaKt5Y"
              >
                <ScrollToTop>
                  <Router />
                </ScrollToTop>
              </LoadScript>
            </ConnectedThemeComponent>
          </I18nextProvider>
        </BrowserRouter>
      </Elements>
    </Provider>
  );
};

export default App;
